import React, { useContext} from "react";
import {AccordionContext, useAccordionToggle} from "react-bootstrap";

export function ContextAwareToggle({ children, eventKey, refForDiv, clickEvent, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        (ev) => {
            if(clickEvent){
                clickEvent(ev);
            }
            callback && callback(eventKey)
        },
    );

    const isCurrentEventKey = currentEventKey === eventKey;
    return (
        <div
            className={isCurrentEventKey ? "active" :"" }
            onClick={decoratedOnClick}
            ref={refForDiv}
        >
            {children}
        </div>
    );
}
